<template>
    <div
        v-click-outside="hide"
        class="md:relative"
    >
        <span
            ref="button"
            class="relative fa-2x cursor-pointer"
            @click="toggleVisibility"
        >
            <div class="flex">
                <font-awesome-icon
                    icon="question"
                    class="text-lg"
                    :class="{ 'text-neutral-dark': layout === 'dark', 'text-white': layout === 'light' }"
                />
            </div>
        </span>
        <div
            v-show="showPopup"
            ref="dropdown"
            class="notifications p-xl flex flex-col text-sm"
        >
            <p>
                Need help? Have suggestions? Visit the Operations Request Portal.
            </p>
            <a
                href="https://operations.openinfra.com"
                target="_blank"
                class="btn btn-md is-primary px-xl"
            >
                Operations Request Portal
            </a>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import Popper from 'popper.js';

    export default {
        directives: {
            ClickOutside,
        },
        props: {
            layout: {
                required: false,
                type: String,
                default: 'dark',
            },
        },
        data() {
            return {
                showPopup: false,
            };
        },
        methods: {
            toggleVisibility() {
                this.showPopup = ! this.showPopup;

                this.$nextTick(() => {
                    new Popper(this.$refs.button, this.$refs.dropdown, {
                        placement: 'bottom',
                    });
                });
            },
            hide() {
                this.showPopup = false;
            },
        },
    };
</script>